import React, { useState } from "react";
import NUSsynapxeimdalogo from "../Assets/NUSsynapxeimdalogo.png";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowDropDownCircleOutlinedIcon from "@mui/icons-material/ArrowDropDownCircleOutlined";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Divider from "@mui/material/Divider";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [openMenu, setOpenMenu] = useState(false);

  return (
    <nav>
      <div className="nav-spacer" />

      <div className="nav-center">
        <div className="nav-logo-container">
          <img src={NUSsynapxeimdalogo} alt="Logos" />
        </div>

        <div className="nav-actions">
          <div className="navbar-links-container">
            <Link to="/">Brief</Link>
            <Link to="/Timeline">Timeline</Link>
            <Link to="/Challenge">Challenge</Link>
            <Link to="/Event">Event</Link>
            <Link to="/Community">Community</Link>
            <Link to="/Teams">Teams</Link>
          </div>

          <a
            href="https://forms.gle/3giRmAv7SB1jKpXg6"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="register-btn">Submit Second Submission</button>
          </a>
        </div>
      </div>

      <div className="navbar-menu-container">
        <div className="menu-text">Menu</div>
        <ArrowDropDownCircleOutlinedIcon
          className="BurgerMenuButton"
          onClick={() => setOpenMenu(true)}
        />
      </div>
      <Drawer open={openMenu} onClose={() => setOpenMenu(false)} anchor="right">
        <Box
          sx={{ width: 200 }}
          role="presentation"
          onClick={() => setOpenMenu(false)}
          onKeyDown={() => setOpenMenu(false)}
        >
          <div className="burgerstyle">
            <div>
              <Link to="/">Brief</Link>{" "}
            </div>
            <div>
              <Link to="/Timeline">Timeline</Link>{" "}
            </div>
            <div>
              <Link to="/Challenge">Challenge</Link>{" "}
            </div>
            <Link to="/Event">Event</Link>{" "}
            <div>
              <Link to="/Community">Community</Link>{" "}
            </div>
            <div>
              <Link to="/teams">Teams</Link>{" "}
            </div>
          </div>

          <Divider />
        </Box>
      </Drawer>
    </nav>
  );
};

export default Navbar;
